import { Injectable } from '@angular/core';
import { LoggingService } from '@app-core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root',
})
/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
export class DateParserFormatterService extends NgbDateParserFormatter {
    readonly DELIMITER = '/';
    readonly JAVA_DELIMITER = '-';

    parse(value: string): NgbDateStruct | null {
        //LoggingService.log("CustomDateParserFormatterService parse " + value);
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[1], 10),
                month: parseInt(date[0], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        let day = '';
        let month = '';
        let year = '';
        if (date) {
            if (!isNaN(parseInt(`${date.day}`, 10))) {
                day = `0${date.day}`.slice(-2);
            }

            if (!isNaN(parseInt(`${date.month}`, 10))) {
                month = `0${date.month}`.slice(-2);
            }

            if (!isNaN(parseInt(`${date.year}`, 10))) {
                year = `00${date.year}`.slice(-4);
            }
        } else {
            LoggingService.log('CustomDateParserFormatterService format - null date');
        }

        return date ? month + this.DELIMITER + day + this.DELIMITER + year : '';
    }

    formatForJava(date: NgbDateStruct | null): string {
        let day = '';
        let month = '';
        if (date) {
            if (!isNaN(parseInt(`${date.day}`, 10))) {
                day = `0${date.day}`.slice(-2);
            }

            if (!isNaN(parseInt(`${date.month}`, 10))) {
                month = `0${date.month}`.slice(-2);
            }
        } else {
            LoggingService.log('CustomDateParserFormatterService format - null date');
        }

        return date ? date.year + this.JAVA_DELIMITER + month + this.JAVA_DELIMITER + day : '';
    }
}
